import axios from "axios";
import { getItem, makeUrl } from "../../app/common/util/genericUtils";

export const createBulkOrderApiCall = (file) => {
  const user = getItem("suprolUser");
  const formData = new FormData();
  formData.append("file", file);

  return axios({
    method: "POST",
    url: makeUrl("/orders/bulk/create"),
    data: formData,
    headers: {
      Authorization: `Token ${user.auth_token}`,
    },
  });
};
